<ng-template #NgContent>
  <ng-content></ng-content>
</ng-template>

<ng-container *ngIf="href">
  <a [ngClass]="{'thin': thin}" [target]="target" [href]="href">
    <ng-template [ngTemplateOutlet]="NgContent"></ng-template>
  </a>
</ng-container>
<ng-container *ngIf="!href">
  <a [ngClass]="{'thin': thin}" [routerLink]="routerLink">
    <ng-template [ngTemplateOutlet]="NgContent"></ng-template>
  </a>
</ng-container>
<ng-container *ngIf="fragment">
  <a [ngClass]="{'thin': thin}" [routerLink]="routerLink" fragment="{{fragment}}">
    <ng-template [ngTemplateOutlet]="NgContent"></ng-template>
  </a>
</ng-container>
